import { createAxiosClient } from "@ntg/component-library/utilities";
import { IOrchestrationInstanceSummary } from "../../declarations/IOrchestrationInstance";
import { useQuery } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

async function fetchOrchestrationDetail(
    instanceId: string,
): Promise<IOrchestrationInstanceSummary> {
    const response = await apiClient.get<IOrchestrationInstanceSummary>(
        `/FunctionAppsStarter/GetOrchestrationDetail/${instanceId}`,
    );
    return response.data;
}

export function useOrchestrationDetail(instanceId: string) {
    return useQuery({
        queryKey: ["orchestration-detail", instanceId],
        queryFn: () => fetchOrchestrationDetail(instanceId),
        enabled: instanceId.length > 0,
        refetchInterval: (data: any) => {
            if (!data) return 2000;

            const status = data?.state?.data?.runtimeStatus;
            if (status === undefined) {
                return 2000;
            }

            if (
                status === "Completed" ||
                status === "Failed" ||
                status === "Terminated"
            ) {
                return false;
            }

            return 2000;
        },
        staleTime: 0,
        refetchOnWindowFocus: false,
    });
}
